export function getCssNumber(css: string, type: string) {
  const arr = css.split(';').filter(item => item.trim() !== '');

  switch (type) {
    case 'top': {
      const idx = arr.findIndex(v => v.trim().startsWith('top:'));
      if (idx > -1) {
        const value = arr[idx].split(':')[1].trim();
        return parseFloat(value.replace(/[^\d.-]/g, ''));
      }
      return 0;
    }
    case 'left': {
      const idx = arr.findIndex(v => v.trim().startsWith('left:'));
      if (idx > -1) {
        const value = arr[idx].split(':')[1].trim();
        return parseFloat(value.replace(/[^\d.-]/g, ''));
      }
      return 0;
    }
    default: {
      return 0;
    }
  }
}
